import React, { useState } from 'react';
import Login from './Login';

export default function AuthGate({ children }) {
  const [authed, setAuthed] = useState(localStorage.getItem('adpilot_auth') === 'true');
  if (!authed) return <Login onLogin={() => setAuthed(true)} />;
  return children;
}
